
import {tap} from 'rxjs/operators';
import { Component } from '@angular/core';
import { LawService } from '../services/law.service';
import { Observable } from 'rxjs';
import { LawNavItem, LawItem } from '../models/models';
import { Router } from "@angular/router";
import { SortOption, SortArgs, SortDirection } from "../../core/models/sort.model";

@Component({
    selector: 'law-library-nav',
    templateUrl: './law-library-nav.component.html',
    styleUrls: ['./law-library-nav.component.scss'],
    standalone: false
})
export class LawLibraryNavComponent {
    navItems$: Observable<LawNavItem[]>;
    fullList: LawItem[];
    navItems: LawItem[];
    currentSearchFilterTerm: string = "";
    currentSort: SortArgs = null;
    sortOptions: SortOption[] = [{ value: "title", display: "Title" } as SortOption, { value: "ORC", display: "ORC/OAC" } as SortOption];
    title: string = "Law Documents";
    static componentName = "LawLibraryNavComponent";

    constructor(
        public lawService: LawService,
        public router: Router
    ) {
        this.navItems$ = this.lawService.getLawNavItems().pipe(tap((result) => {
            this.navItems = [];
            this.fullList = [];
            result.forEach(r => {
                this.navItems.push(new LawItem(r));
                this.fullList.push(new LawItem(r));
            });
        }));

        this.lawService.onLawDeleted.subscribe((id) => {
            this.fullList.splice(this.fullList.findIndex(x => x.id == id, 1));
            if (this.navItems.findIndex(x => x.id == id) !== -1) {
                this.navItems.splice(this.navItems.findIndex(x => x.id === id), 1);
            }            
        });

        this.lawService.onLawUpdated.subscribe((result) => {
            let index = this.fullList.findIndex(x => x.id === result.id);
            this.fullList[index] = new LawItem(result);
            index = this.navItems.findIndex(x => x.id === result.id);
            if (index !== -1) {
                this.navItems[index] = new LawItem(result);
            }            
        });

        this.lawService.onLawCreated.subscribe((result) => {
            let newLaw = new LawItem(result);
            this.fullList.unshift(newLaw);
            if (this.currentSort !== null) {
                this.sortChanged(this.currentSort);
            }
            if (this.currentSearchFilterTerm.length > 0) {
                this.searchOrFilter(this.currentSearchFilterTerm);
            }
        });
    }   

    navigate(id: string) {
        this.router.navigateByUrl(`law-library/${id}/preview`);
    }

    searchOrFilter(term: string): void {
        if (this.currentSearchFilterTerm !== term) {
            this.currentSearchFilterTerm = term;
        }        
        if (term.length > 0) {
            this.navItems = this.fullList.filter(ni => ni.orc.indexOf(term) !== -1 || ni.name.indexOf(term) !== -1);
        } else {
            this.navItems = this.fullList;
        } 
    }

    sortChanged(args: SortArgs) {
        this.currentSort = args;
        if (args !== null) {
            switch (args.sortProperty.toUpperCase()) {
                case "ORC":
                    if (args.sortDirection === SortDirection.Ascending) {
                        this.navItems = this.fullList.sort((a, b) => {
                            if (a.orc < b.orc) return -1;
                            if (a.orc > b.orc) return 1;
                            return 0;
                        });
                    } else {
                        this.navItems = this.fullList.sort((a, b) => {
                            if (a.orc < b.orc) return 1;
                            if (a.orc > b.orc) return -1;
                            return 0;
                        });
                    }
                    break;
                case "TITLE":
                    if (args.sortDirection === SortDirection.Ascending) {
                        this.navItems = this.fullList.sort((a, b) => {
                            if (a.name < b.name) return -1;
                            if (a.name > b.name) return 1;
                            return 0;
                        });
                    } else {
                        this.navItems = this.fullList.sort((a, b) => {
                            if (a.name < b.name) return 1;
                            if (a.name > b.name) return -1;
                            return 0;
                        });
                    }
                    break;
            }
        } else {
            this.navItems = this.fullList;
        }
        
    }
}
